import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NewsDetailsPost from './NewsDetailsPost';

function NewsDetails(props) {
    const { layout } = props;
    let content;
    if (layout === 'classic') {
        content = (
            <NewsDetailsPost layout={layout} />
        );
    } else if (layout === 'full') {
        content = (
            <div className="row justify-content-center">
                <div className="col-md-12 col-lg-8 col-xl-8">
                    <NewsDetailsPost layout={layout} />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {content}
        </React.Fragment>
    );
}

NewsDetails.propTypes = {
    layout: PropTypes.oneOf(['classic', 'full']),
};

NewsDetails.defaultProps = {
    layout: 'classic',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(NewsDetails);
